export default __webpack_public_path__ + "icons.svg?5cc8281c1aa761772bee1bf731175871";